import { useContext } from 'react';

import PageHeader from '@/components/PageHeader';
import PersonContext from '@/pages/Person/PersonContext';
import Container from '@/ui/components/Container';

import ImpersonateCard from './components/ImpersonateCard';
import TwoFactorCard from './components/TwoFactorCard';
import type { Props } from './types';

/** A person's sign-in tools for staff, one card per tool they have permission for. */
const PersonAuthentication = ({ canImpersonate, canResetMfa }: Props) => {
  const {
    person: { id, first_name, last_name }
  } = useContext(PersonContext);
  const name = `${first_name} ${last_name}`;

  return (
    <Container type="page">
      <PageHeader headingText="Authentication" className="sr-only" />
      <div className="mx-auto max-w-3xl space-y-4">
        {canResetMfa && <TwoFactorCard personId={id} name={name} />}
        {canImpersonate && <ImpersonateCard personId={id} name={name} />}
      </div>
    </Container>
  );
};

export default PersonAuthentication;
